<template>
    <blank-layout>


        <div class="-mt-6 flex flex-grow flex-col">

            <div class="flex flex-col md:flex-row w-full flex-grow">


                <div v-if="stage == 'success' || stage == 'done'"
                    class="flex flex-grow bg-white flex-col justify-center items-center">

                    <div class="flex flex-col w-full max-w-xl">


                        <div>
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-3">
                                <img src="/img/logo-black-website.svg" width="160" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-2 uppercase">+</span>
                                <img src="/img/jsm-logo.svg" width="40" alt="Jira Service Management Logo"
                                    class="align-center ml-3 mt-1" />
                            </h3>
                        </div>
                        <h1 v-if="stage == 'success'" class="text-center text-2xl mt-3 text-gray-700">Congratulations!
                        </h1>
                        <h1 v-else class="text-center text-2xl mt-3 text-gray-700">Your installation is complete</h1>

                        <p>&nbsp;</p>

                        <div class="mt-10 rounded-md bg-indigo-100 p-6">
                            <p class="text-center">You can already start using Birdie with Jira!</p>
                            <p class="text-center">If you need any help head to our <a
                                    href="https://docs.birdie.so/birdie-docs/helpdesk/jira-service-management"
                                    target="_blank">help center page 👉</a></p>
                        </div>


                    </div>
                </div>

                <div v-else class="flex flex-grow bg-white flex-col justify-center items-center">


                    <div class="flex flex-col w-full max-w-xl">

                        <div>
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-3">
                                <img src="/img/logo-black-website.svg" width="160" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-2 uppercase">+</span> <img
                                    src="/img/jsm-logo.svg" width="40" alt="Logo" class="" />
                            </h3>
                        </div>

                        <h1 class="text-center text-2xl mt-3 text-gray-700">Get started with Screen Recording by {{
                            $page.props.app_name }}</h1>

                        <p>&nbsp;</p>

                        <p class="text-lg text-center">Connect to your Birdie account, or create a new one for free.</p>

                        <p>&nbsp;</p>

                        <jet-form @submitted="submitInstall">

                            <template #form>


                                <transition name="fade">
                                    <div class="flex flex-row items-center" v-if="stage != 'success'">

                                        <jet-label v-if="stage != 'sign_up'" for="email" value="Email"
                                            class="text-xl text-gray-600 font-bold self-center" />

                                        <jet-input id="email" type="email" class=" block flex-grow" v-model="form.email"
                                            ref="email" autocomplete="email" placeholder="john@empire.com" :class="{
                                                'mr-3': stage == 'init' || stage == 'sign_up',
                                                'ml-3': stage != 'sign_up'
                                            }" :disabled="stage == 'sign_up'" />

                                        <jet-input-error :message="form.errors.email" class="mt-2" />

                                        <jet-button v-if="stage == 'init'"
                                            class="bg-blue-500 text-white hover:bg-blue-400"
                                            :class="{ 'opacity-25': form.processing }"
                                            :disabled="form.processing || !is_email_complete">
                                            Next <vue-feather type="arrow-right" class="h-4 w-4 ml-2" />
                                        </jet-button>

                                        <a href="#" v-else-if="stage == 'sign_up'"
                                            class="bg-white text-gray-400 hover:text-gray-300 cursor-pointer flex items-center"
                                            :class="{ 'opacity-25': form.processing }" @click.prevent="reset()">
                                            <vue-feather type="x" class="h-4 w-4 mr-2" /> Change
                                        </a>

                                    </div>
                                </transition>

                                <transition name="fade">
                                    <div class="mt-5" v-if="stage == 'sign_in'">
                                        <p>Enter the verification code we sent to your inbox.</p>
                                        <div class="flex flex-row mt-5">
                                            <jet-label for="password" value="Code"
                                                class="text-xl text-gray-600 font-bold self-center" />
                                            <jet-input id="password" type="text" class="mx-3 block flex-grow"
                                                v-model="form.password" ref="password" @input="codeChanged" required
                                                maxlength="6" minlength="6" />
                                            <jet-button class="bg-blue-500 text-white hover:bg-blue-400"
                                                :class="{ 'opacity-25': form.processing }"
                                                :disabled="form.processing || !is_password_complete">
                                                Connect <vue-feather type="arrow-right" class="h-4 w-4 ml-2" />
                                            </jet-button>
                                        </div>
                                        <jet-input-error :message="form.errors.password" class="mt-2" />
                                        <p v-if="false" class="mt-5 text-right"><a
                                                :href="$page.props.app_url + '/forgot-password'" target="_blank"
                                                class="text-sm hover:underline text-gray-500">Forgot
                                                your password?</a></p>
                                    </div>
                                </transition>



                                <transition name="fade">
                                    <div class="mt-5" v-if="stage == 'sign_up'">

                                        <p>This account does not exist yet, <a :href="$page.props.app_url + '/hello'"
                                                target="_blank">please
                                                click here to sign up for a Free Birdie account</a> and come back here
                                            to sign in with your new account.</p>

                                        <!-- <p>Add your contact details to activate Jira Service Management App.</p> -->

                                        <!-- <div class="">
                                            <jet-label for="fullname" value="Full name" class="font-bold text-base" />
                                            <jet-input id="fullname" type="text" class="mt-1 block w-full"
                                                v-model="form.fullname" ref="fullname" autocomplete="fullname"
                                                placeholder="John Doe" />
                                            <jet-input-error :message="form.errors.fullname" class="mt-2" />
                                        </div>

                                        <div class="mt-6">
                                            <jet-label for="company" value="Company" class="font-bold text-base" />
                                            <jet-input id="company" type="text" class="mt-1 block w-full"
                                                v-model="form.company" ref="company" autocomplete="company"
                                                placeholder="Empire" debounce="500" />
                                            <jet-input-error :message="form.errors.company" class="mt-2" />
                                        </div>

                                        <div class="mt-6">
                                            <jet-label for="password" value="Create your password"
                                                class="font-bold text-base" />
                                            <jet-input id="password" type="password" class="mt-1 block w-full"
                                                v-model="form.password" ref="password" />
                                            <jet-input-error :message="form.errors.password" class="mt-2" />
                                            <small>Your password must be at least 8 characters long</small>
                                        </div>


                                        <div class="mt-6 mb-5">
                                            <jet-label for="" value="What best describes what you do?"
                                                class="font-bold text-base" />
                                            <options-radio :options="[{ label: 'General Support', value: 'general_support' },
                                            { label: 'Technical Support', value: 'technical_support' },
                                            { label: 'Customer Success', value: 'customer_success' },
                                            { label: 'Other', value: 'other' }]" checked=""
                                                @update="updatedJob"></options-radio>
                                            <jet-input-error :message="form.errors.job" class="mt-2" />
                                        </div>



                                        <jet-button class="bg-blue-500 text-white hover:bg-blue-400"
                                            :class="{ 'opacity-25': form.processing }"
                                            :disabled="form.processing || !is_signup_complete">
                                            Sign up <vue-feather type="arrow-right" class="h-4 w-4 ml-2" />
                                        </jet-button>


                                        <jet-input-error :message="form.errors.signup" class="mt-2" /> -->

                                    </div>
                                </transition>



                            </template>

                        </jet-form>


                    </div>


                </div>


            </div>


        </div>

    </blank-layout>
</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetButton from '@/Jetstream/Button'
//import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetForm from '@/Jetstream/Form'
import JetLabel from '@/Jetstream/Label'
import OptionsRadio from '@/Components/UI/OptionsRadio'
import moment from 'moment-timezone'

export default {
    props: [
        'integration', 'user'
    ],


    components: {
        BlankLayout, JetInput, JetInputError, JetLabel,
        JetButton, JetForm, OptionsRadio, //JetActionMessage, // OptionsRadio,
        //JetDialogModal, JetSecondaryButton,

    },
    data() {
        return {
            form: this.$inertia.form({
                email: "",
                password: "",
                stage: "init"
            }),
            email: "",
            password: "",
            stage: "init", // init, sign_in, success, sign_up, done
            email_known: false,
            team_id: null,
            user: null,
            url: this.$page.props.app_url + '/jira/startform',
            timezone: '',
        }
    },
    created() {
        // if (this.details.emailAddress) {
        //     this.form.email = this.details.emailAddress
        // }

        this.moment = moment;
        this.form.timezone = this.moment.tz.guess()

        if (this.integration.team_id) {
            this.stage = "done"
            this.force_resync()
        } else {
            this.stage = "init"
        }

        var self = this
        AP.getLocation(function (location) {
            //console.log("app_location", location)
            var url = new URL(location)
            const email_get = url.searchParams.get("email")
            if (email_get) {
                self.email = email_get
                self.form.email = email_get
            }
            //console.log("FORM ?? ", self.form.email);
        });

        // AP.request("/rest/atlassian-connect/1/addons/zest-screen-recording/properties/teamData", {
        //     success: function(responseText) {
        //         console.log("teamData Success", responseText)
        //         let responseJson = JSON.parse(responseText)
        //         //self.team_data = responseJson.value
        //         //console.log("App teamData", responseJson.value);
        //         //self.checkCompleteAuth()
        //     },
        //     error: function(xhr, statusText, errorThrown){
        //         console.error("App teamData", xhr.status)
        //         if (xhr.status == 401 && self.app_location != "") {
        //             //self.guess_integration_from_location(self.app_location)
        //         } else {
        //             // self.team_data = null
        //             // self.checkCompleteAuth()
        //         }
        //     }
        // });


    },
    beforeUnmount() {

    },
    mounted() {

    },
    computed: {
        is_email_complete() {
            return this.validateEmail(this.form.email)
        },
        is_password_complete() {
            return (this.validateEmail(this.form.email)
                && this.form.password.trim().length == 6)
        },
        is_signup_complete() {
            return (this.validateEmail(this.form.email)
                && this.form.password.trim().length >= 8
                && this.form.fullname.trim().length >= 3
                && this.form.company.trim().length >= 2
                && this.form.job.trim().length >= 1)
        }
    },
    methods: {
        force_resync() {
            let params = {
                integration_id: this.integration.id,
                team_id: this.integration.team_id,
                action: "force_resync"
            }
            axios.post(this.url, params)
                .then(response => {
                    //console.log(response.data)
                })
                .catch(e => {
                    console.error(e)
                });
        },
        test_email_existence() {
            let params = {
                email: this.form.email,
                action: "test_email_existence"
            }
            this.form.processing = true
            axios.post(this.url, params)
                .then(response => {
                    //console.log("test_email_existence", response.data)
                    this.form.processing = false
                    //this.team_data = response.data
                    //console.log(response.data)
                    this.email_known = response.data.email_known
                    this.team_id = response.data.team_id
                    if (this.team_id != null) {
                        this.stage = "sign_in"
                    } else {
                        this.stage = "sign_up"
                        this.$nextTick(() => {
                            this.$refs.fullname.focus()
                        })
                    }
                })
                .catch(e => {
                    this.form.processing = false
                    console.error(e)
                });
        },
        test_login() {
            let params = {
                email: this.form.email,
                password: this.form.password,
                action: "sign_in",
                integration_id: this.integration.id
            }
            this.form.errors = {}
            this.form.processing = true
            axios.post(this.url, params)
                .then(response => {
                    this.form.processing = false
                    this.user = response.data.user
                    if (this.user == null) {
                        this.form.password = ""
                        this.form.errors.password = "Wrong code, please double-check and retry"
                    } else {
                        this.stage = "success"
                    }
                })
                .catch(e => {
                    this.form.processing = false
                    console.error(e)
                });
        },
        do_signup() {
            let params = {
                email: this.form.email,
                password: this.form.password,
                fullname: this.form.fullname,
                company: this.form.company,
                job: this.form.job,
                action: "sign_up",
                timezone: this.form.timezone,
                integration_id: this.integration.id
            }
            this.form.errors = {}
            this.form.processing = true
            axios.post(this.url, params)
                .then(response => {
                    this.form.processing = false
                    //console.log(response.data)
                    this.user = response.data.user
                    if (this.user == null) {
                        let domain = this.$page.props.app_url.split('.').slice(-2).join('.')
                        this.form.errors.signin = "An error occured, please contact support@" + domain
                    } else {
                        this.stage = "success"
                    }
                })
                .catch(e => {
                    this.form.processing = false
                    console.error(e)
                });
        },
        submitInstall() {
            if (this.stage == "init") {
                this.test_email_existence()
            } else if (this.stage == "sign_in") {
                this.test_login()
            } else if (this.stage == "sign_up") {
                this.do_signup()
            }

            return

            let path = "/jira/getstarted"
            this.form.get(path, {
                errorBag: 'submitInstall',
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
                onError: () => {
                    if (this.form.errors.email) {
                        this.form.reset('email')
                        this.$refs.email.focus()
                    }
                }
            })
        },
        reset() {
            this.form.email = ""
            this.form.password = ""
            this.form.stage = "init"
            this.form.errors = {}
            this.form.job = ""
            this.form.company = ""
            this.form.fullname = ""
            this.email = ""
            this.password = ""
            this.stage = "init"
            this.email_known = false
            this.team_id = null
            this.user = null
        },
        updatedJob(value) {
            //console.log("updatedJob", value)
            this.form.job = value
        },
        validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateNotempty(value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        }
    }
}
</script>

<style scoped>
.sidebar_gradient {
    background: -webkit-linear-gradient(#fafbfc, #e2e5e7);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}


.slide-fade-enter-active {
    transition: all .3s ease-out;
}

.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}
</style>
